<template>
  <div>
    <h1 style="margin-top: 0">404 Not Found</h1>
    <p><a href="/#/login">返回首页</a></p>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>
